"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.material = void 0;
const createColorScheme_1 = require("../createColorScheme");
exports.material = (0, createColorScheme_1.createColorScheme)("material", {
    bg: "#212121",
    fg: "#b9b9b9",
    primary: "#4CAF50",
    secondary: "#ab47bc",
}, {
    red: "#ef5350",
    green: "#66bb6a",
    yellow: "#ffee58",
    blue: "#42a5f5",
    purple: "#ab47bc",
    cyan: "#26c6da",
    orange: "#ffa726",
});
